import { PRODUCT_SELECTED } from "../actions/products/types";
import { useSelector } from "react-redux";

const initialState = {
  selectedProduct: null,
};

export const productReducer = (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_SELECTED:
      return {
        ...state,
        selectedProduct: payload,
      };
    default:
      return state;
  }
};

export function useSelectedProduct() {
  return useSelector((state) => {
    return state.products.selectedProduct;
  });
}
